import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

/* import API function from services folder */
import { FetchWorkshops } from "../../services/common";

const Workshops = ({ values = [], onChange }) => {
    const [source, setSource] = useState([]);

    const handleChange = ({ target }) => {
        const { value, checked } = target;

        if (checked)
            onChange({ target: { name: 'workshops', value: [...values, value] } })
        else {
            const _selected = [...values];
            const index = _selected.indexOf(value);
            
            _selected.splice(index, 1);

            onChange({ target: { name: 'workshops', value: _selected } })
        }
    };

    useEffect(() => {
        FetchWorkshops().then( response => {
            setSource(response);
        })
        .catch( error => console.log(error));
    }, []);

    return (
        <div className="work-shops-canvas">
            {
                source?.map(item => (
                    <Form.Check type="checkbox" key={ item.code } value={ item.code } label={ item.name } checked={ values.includes(item.code) } onChange={ handleChange } />
                ))
            }
        </div>
    )
};

export default React.memo(Workshops);